module.exports = __webpack_public_path__ + "static/rollover_vacaciones-f0bb31c0eb01565d98e38767d86408b1.svg";